import React from 'react';
import styles from './Btn.module.css';
import Ico from './Ico';
import clx from './clx';

const ICO_SPIN = 'M23 4v6h-6M1 20v-6h6M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15';

export default function Btn({
  size = 'md',
  variant = 'secondary',
  icon,
  loading = false,
  disabled = false,
  onClick,
  type = 'button',
  children,
  className,
}) {
  return (
    <button
      type={type}
      className={clx(styles.btn, styles[size], styles[variant], className)}
      disabled={disabled || loading}
      onClick={onClick}
    >
      {loading
        ? <Ico d={ICO_SPIN} size={14} style={{ animation: 'hvSpin 1s linear infinite' }} />
        : icon
          ? <Ico d={icon} size={14} />
          : null
      }
      {children}
    </button>
  );
}
